<nz-table
  data-test="watchlist-grid"
  #watchlistTable
  class="watchlist-grid"
  [nzOuterBordered]="true"
  [ngClass]="{ 'grid-with-filter': showGridFilter }"
  nzShowSizeChanger
  [nzData]="listOfDisplayData"
  [nzScroll]="{ x: '2530px', y: 'calc(100vh - 380px)' }"
  (nzCurrentPageDataChange)="onCurrentPageDataChange($event)"
  [nzWidthConfig]="widthConfig"
  nzSize="small"
  [nzPageSizeOptions]="[12, 24, 48, 96]"
  [nzPageSize]="24"
  [nzShowTotal]="totalTemplate"
  [nzLoading]="watchlistGridLoading || isGridLoading"
>
  <thead nzSingleSort>
    <tr>
      <th
        [nzSortFn]="undefined"
        [nzShowSort]="true"
        [(nzSortOrder)]="mapOfSort.ticker"
        (nzSortOrderChange)="sort('ticker', $event)"
        nzLeft="0px"
      >
        Ticker
      </th>
      <th
        [nzSortFn]="undefined"
        [nzShowSort]="true"
        [(nzSortOrder)]="mapOfSort.bbgTicker"
        (nzSortOrderChange)="sort('bbgTicker', $event)"
      >
        BBG Ticker
      </th>
      <th
        [nzSortFn]="undefined"
        [nzShowSort]="true"
        [(nzSortOrder)]="mapOfSort.name"
        (nzSortOrderChange)="sort('name', $event)"
      >
        Company
      </th>
      <th
        [nzSortFn]="undefined"
        [nzShowSort]="true"
        [(nzSortOrder)]="mapOfSort.lastModelReceivedSort"
        (nzSortOrderChange)="sort('lastModelReceivedSort', $event)"
      >
        Last Model Received
      </th>
      <th
        [nzSortFn]="undefined"
        [nzShowSort]="true"
        [(nzSortOrder)]="mapOfSort.lastRevisionsDateSort"
        (nzSortOrderChange)="sort('lastRevisionsDateSort', $event)"
      >
        Last Revisions Date
      </th>
      <th
        [nzSortFn]="undefined"
        [nzShowSort]="true"
        [(nzSortOrder)]="mapOfSort.lastReportedEarningsSort"
        (nzSortOrderChange)="sort('lastReportedEarningsSort', $event)"
      >
        Last Reported Earnings
      </th>
      <th
        [nzSortFn]="undefined"
        [nzShowSort]="true"
        [(nzSortOrder)]="mapOfSort.nextEarningsSort"
        (nzSortOrderChange)="sort('nextEarningsSort', $event)"
      >
        Next Earnings
      </th>
      <th
        [nzSortFn]="undefined"
        [nzShowSort]="true"
        [(nzSortOrder)]="mapOfSort.coveragestatus"
        (nzSortOrderChange)="sort('coveragestatus', $event)"
      >
        Coverage Status
      </th>
      <th
        class="right-align"
        [nzSortFn]="undefined"
        [nzShowSort]="true"
        [(nzSortOrder)]="mapOfSort.sources"
        (nzSortOrderChange)="sort('sources', $event)"
      >
        Sources
      </th>
      <th
        [nzSortFn]="undefined"
        [nzShowSort]="true"
        [(nzSortOrder)]="mapOfSort.initiationDateSort"
        (nzSortOrderChange)="sort('initiationDateSort', $event)"
      >
        Initiation Date
      </th>
      <th
        [nzSortFn]="undefined"
        [nzShowSort]="true"
        [(nzSortOrder)]="mapOfSort.country"
        (nzSortOrderChange)="sort('country', $event)"
      >
        Country
      </th>
      <th
        [nzSortFn]="undefined"
        [nzShowSort]="true"
        [(nzSortOrder)]="mapOfSort.region"
        (nzSortOrderChange)="sort('region', $event)"
      >
        Region
      </th>
      <th
        [nzSortFn]="undefined"
        [nzShowSort]="true"
        [(nzSortOrder)]="mapOfSort.sector"
        (nzSortOrderChange)="sort('sector', $event)"
      >
        Sector
      </th>
      <th
        [nzSortFn]="undefined"
        [nzShowSort]="true"
        [(nzSortOrder)]="mapOfSort.industry"
        (nzSortOrderChange)="sort('industry', $event)"
      >
        Industry
      </th>
    </tr>
    <tr *ngIf="showGridFilter">
      <th nzLeft="0px">
        <nz-input-group [nzSuffix]="tickerClearTemplate" nzSize="small">
          <input
            nz-input
            (keyup)="filterApplied($event, 'ticker')"
            [(ngModel)]="appliedFilter.ticker"
            placeholder=""
            nzSize="small"
          />
        </nz-input-group>
      </th>
      <th>
        <nz-input-group [nzSuffix]="bbgTickerClearTemplate" nzSize="small">
          <input
            nz-input
            (keyup)="filterApplied($event, 'bbgTicker')"
            [(ngModel)]="appliedFilter.bbgTicker"
            placeholder=""
            nzSize="small"
          />
        </nz-input-group>
      </th>
      <th>
        <nz-input-group [nzSuffix]="companyNameClearTemplate" nzSize="small">
          <input
            nz-input
            (keyup)="filterApplied($event, 'name')"
            [(ngModel)]="appliedFilter.name"
            placeholder=""
            nzSize="small"
            style="width: 220px"
          />
        </nz-input-group>
      </th>
      <th></th>
      <th></th>
      <th></th>
      <th></th>
      <th>
        <nz-select
          [nzDropdownClassName]="'grid-filter-select-dropdown'"
          style="width: 130px"
          (ngModelChange)="filterApplied($event, 'coveragestatus')"
          [(ngModel)]="appliedFilter.coveragestatus"
          [nzSize]="'small'"
          [nzDisabled]="coveragestatusList.length < 2"
        >
          <nz-option
            *ngFor="let option of coveragestatusList"
            [nzLabel]="option"
            [nzValue]="option"
          ></nz-option>
        </nz-select>
      </th>
      <th>
        <nz-input-group [nzSuffix]="sourcesClearTemplate" nzSize="small">
          <input
            nz-input
            (keyup)="filterApplied($event, 'sources')"
            [(ngModel)]="appliedFilter.sources"
            placeholder=""
            nzSize="small"
          />
        </nz-input-group>
      </th>
      <th></th>
      <th>
        <nz-input-group [nzSuffix]="countryClearTemplate" nzSize="small">
          <input
            nz-input
            (keyup)="filterApplied($event, 'country')"
            [(ngModel)]="appliedFilter.country"
            placeholder=""
            nzSize="small"
          />
        </nz-input-group>
      </th>
      <th>
        <nz-select
          [nzDropdownClassName]="'grid-filter-select-dropdown'"
          style="width: 150px"
          (ngModelChange)="filterApplied($event, 'region')"
          [(ngModel)]="appliedFilter.region"
          [nzSize]="'small'"
          [nzDisabled]="regionList.length < 2"
        >
          <nz-option
            *ngFor="let option of regionList"
            [nzLabel]="option"
            [nzValue]="option"
          ></nz-option>
        </nz-select>
      </th>
      <th>
        <nz-select
          [nzDropdownClassName]="'grid-filter-select-dropdown'"
          style="width: 140px"
          (ngModelChange)="filterApplied($event, 'sector')"
          [(ngModel)]="appliedFilter.sector"
          [nzSize]="'small'"
          [nzDisabled]="sectorList.length < 2"
        >
          <nz-option
            *ngFor="let option of sectorList"
            [nzLabel]="option"
            [nzValue]="option"
          ></nz-option>
        </nz-select>
      </th>
      <th>
        <nz-input-group [nzSuffix]="industryClearTemplate" nzSize="small">
          <input
            nz-input
            (keyup)="filterApplied($event, 'industry')"
            [(ngModel)]="appliedFilter.industry"
            placeholder=""
            nzSize="small"
          />
        </nz-input-group>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let data of watchlistTable.data"
      [ngClass]="{ 'selected-row': this.setOfCheckedId.has(data.ticker) }"
    >
      <td nzLeft="0px">
        <a title="View Company Page" routerLink="/company/{{ data.ticker }}">
          {{ data.ticker }}
        </a>
      </td>
      <td>
        <a title="View Company Page" routerLink="/company/{{ data.ticker }}">
          {{ data.bbgTicker }}
        </a>
      </td>
      <td>
        <span *ngIf="data.name.length <= 28">
          <a title="View Company Page" routerLink="/company/{{ data.ticker }}">
            {{ data.name }}
          </a>
        </span>
        <span
          *ngIf="data.name.length > 28"
          [nzTooltipTitle]="data.name"
          nz-tooltip
        >
          <a title="View Company Page" routerLink="/company/{{ data.ticker }}">
            {{ data.name }}
          </a>
        </span>
      </td>
      <td>
        {{ data.lastModelReceived }}
        <va-icon
          isFontAwesome="true"
          *ngIf="!!data.lastModelReceived && !!data.latestSourceId"
          class="infoIcon"
          [name]="faInfoCircle"
          nz-popover
          [nzPopoverContent]="sourceShortNameTemplate"
          nzPopoverTrigger="hover"
          nzPopoverPlacement="right"
          (mouseenter)="getSourceTooltip(data)"
        >
        </va-icon>
        <ng-template #sourceShortNameTemplate>
          <span *ngIf="showSourceTooltip">{{ data.sourceShortName }}</span>
          <!-- added loader in-case api is slow -->
          <nz-spin
            *ngIf="!showSourceTooltip"
            nzSimple
            [nzSize]="'small'"
          ></nz-spin>
        </ng-template>
      </td>
      <td>{{ data.lastRevisionsDate }}</td>
      <td>{{ data.lastReportedEarnings }}</td>
      <td>{{ data.nextEarnings }}</td>
      <td>{{ data.coveragestatus }}</td>
      <td class="right-align">{{ data.sources }}</td>
      <td>{{ data.initiationDate }}</td>
      <td>{{ data.country }}</td>
      <td>
        <span *ngIf="data.region.length <= 20">{{ data.region }}</span>
        <span
          *ngIf="data.region.length > 20"
          [nzTooltipTitle]="data.region"
          nz-tooltip
          >{{ data.region }}</span
        >
      </td>
      <td>
        <a
          title="{{ data.sector }}"
          routerLink="/reporting/sector/{{ data.sector }}"
        >
          {{ data.sector }}
        </a>
      </td>
      <td>
        <a
          title="{{ data.industry }}"
          routerLink="/comparative-analysis/current"
          [queryParams]="{
            comp_type: 'industry',
            id: data.industry_id,
            sub_id: -1
          }"
        >
          {{ data.industry }}
        </a>
      </td>
    </tr>
  </tbody>
</nz-table>
<ng-template #totalTemplate let-total let-range="range">
  {{ range[0] }} to {{ range[1] }} of {{ listOfDisplayData.length }}
</ng-template>

<ng-template #tickerClearTemplate>
  <va-icon
    size="small"
    name="close-circle"
    *ngIf="appliedFilter.ticker"
    (click)="onClearFilter('ticker')"
    class="close-circle-icon"
  ></va-icon>
</ng-template>
<ng-template #bbgTickerClearTemplate>
  <va-icon
    size="small"
    name="close-circle"
    *ngIf="appliedFilter.bbgTicker"
    (click)="onClearFilter('bbgTicker')"
    class="close-circle-icon"
  ></va-icon>
</ng-template>

<ng-template #companyNameClearTemplate>
  <va-icon
    size="small"
    name="close-circle"
    *ngIf="appliedFilter.name"
    (click)="onClearFilter('name')"
    class="close-circle-icon"
  ></va-icon>
</ng-template>

<ng-template #sourcesClearTemplate>
  <va-icon
    size="small"
    name="close-circle"
    *ngIf="appliedFilter.sources"
    (click)="onClearFilter('sources')"
    class="close-circle-icon"
  ></va-icon>
</ng-template>

<ng-template #countryClearTemplate>
  <va-icon
    size="small"
    name="close-circle"
    *ngIf="appliedFilter.country"
    (click)="onClearFilter('country')"
    class="close-circle-icon"
  ></va-icon>
</ng-template>

<ng-template #industryClearTemplate>
  <va-icon
    size="small"
    name="close-circle"
    *ngIf="appliedFilter.industry"
    (click)="onClearFilter('industry')"
    class="close-circle-icon"
  ></va-icon>
</ng-template>
